import { render } from "./CardDetail.vue?vue&type=template&id=dd7d0d58"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"
script.render = render

export default script